export default {
  // 拡張配分比率取得
  getAllocationRatios: (state) => {
    return state.ticketMasterAllocationRatios;
  },
  // 拡張配分比率取得(マップ)
  getAllocationRatiosByMap: (state) => {
    return state.ticketMasterAllocationRatios.reduce((obj, item) => {
      obj[item.ticketID+"_"+item.identifier] = item;
      return obj
    }, {});
  },
  getAttributeMaster: (state) => {
    return state.attributeMaster;
  },
  getAttributeMasterByMap: (state) => {
    return state.attributeMaster.reduce((obj, item) => {
      obj[item.id] = item;
      return obj;
    }, {});
  },
  getAttributeUsersByMap: (state) => {
    return state.attributeUsers.reduce((obj, item) => {
      obj[item.id] = item;
      return obj;
    }, {});
  },
  getCompanyMaster: (state) => {
    return state.companyMaster;
  },
  getCompanyMasterByMap: (state) => {
    return state.companyMaster.reduce((obj, item) => {
      obj[item.id] = item;
      return obj;
    }, {});
  },
  getExternalLowerLinkMasterByMap: (state) => {
    return state.externalLowerLinkMaster.reduce((obj, item) => {
      obj[item.id] = item;
      return obj;
    }, {});
  },
  getStationListMaster: (state) => {
    return state.stationListMaster;
  },
  getStationListMasterByMap: (state) => {
    return state.stationListMaster.reduce((obj, item) => {
      obj[item.id] = item;
      return obj;
    }, {});
  },
  getTicketMaster: (state) => {
    return state.ticketMaster;
  },
  getTicketMasterByMap: (state) => {
    return state.ticketMaster.reduce((obj, item) => {
      obj[item.id] = item;
      return obj;
    }, {});
  },
  getOptionMaster: (state) => {
    return state.optionMaster;
  },
  getOptionMasterByMap: (state) => {
    return state.optionMaster.reduce((obj, item) => {
      obj[item.id] = item;
      return obj;
    }, {});
  },
  getPriceMaster: (state) => {
    return state.priceMaster;
  },
  getPriceMasterByMap: (state) => {
    return state.priceMaster.reduce((obj, item) => {
      obj[item.identifier] = item;
      return obj;
    }, {});
  },
  getMembers: (state) => {
    return state.members;
  },
  getMemberIDByMap: (state) => {
    return state.members.reduce((obj, item) => {
      obj[item.userID] = item.id;
      return obj;
    }, {});
  },
};
